<template>
  <b-container fluid>
    <!-- Searching Parameters -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('report.mon_fin_repo') }} {{ $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-overlay :show="dataLoad">
        <b-row>
          <b-col xl="12" lg="12" sm="12">
            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
              <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                <b-row>
                  <!-- Division -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="Division" vid="division_id">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="division_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.division')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="search.division_id"
                          :options="divisionList"
                          id="division_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- District -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="District" vid="district_id">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="district_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.district')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="search.district_id"
                          :options="districtList"
                          id="district_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Upazilla -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="Upazilla" vid="upazilla_id">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="upazilla_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.upazila')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="search.upazilla_id"
                          :options="upazillaList"
                          id="upazilla_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Hospital -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="Hospital" vid="hospital_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="hospital_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.hospital')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.hospital_id"
                          :options="hospitalList"
                          id="hospital_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Year -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="year" vid="fiscal_year_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="fiscal_year_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('retailerManagement.year')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.fiscal_year_id"
                          :options="yearList"
                          id="fiscal_year_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <!-- Month -->
                  <b-col xl="6" lg="6" sm="12">
                    <ValidationProvider name="Month" vid="month_id" rules="required|min_value:1">
                        <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="month_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('production_store.month')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="search.month_id"
                          :options="monthList"
                          id="month_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Search Button -->
                  <b-col xl="6" lg="6" sm="12">&nbsp;</b-col>
                  <b-col xl="6" lg="6" sm="12">
                    <div class="col text-right">
                      <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.search') }}</b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </ValidationObserver>
          </b-col>
        </b-row>
        </b-overlay>
      </template>
    </iq-card>
    <!-- /Searching Parameters -->
    <!-- <b-modal id="modal-detail-umo" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Report :testList="testOptionList"/>
    </b-modal> -->
    <template>
      <b-overlay :show="loadingPdf">
          <b-row>
            <b-col lg="12" sm="12">
              <iq-card>
                <template>
                <b-overlay v-if="unitLoad">
                <!-- report head data -->
                <!-- PDF -->
                <b-col xs="12" sm="12" md="12" class="text-right mt-4" style="margin-left: -5px">
                    <b-button-group>
                        <b-button @click="pdfExport" variant="success"><i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i></b-button>
                      </b-button-group>
                </b-col>
                <b-row v-if="reportHeadData">
                    <b-col xs="12" sm="12" md="3" class="text-right mt-4">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                        <h3 class="text-bold">
                            {{ $t('production_store.govt_info') }}
                        </h3>
                        <h4 class="text-center text-dark">
                            {{ $t('social_service.dss') }}
                        </h4>
                        <!-- <span class="text-center text-dark">
                            {{ reportHeadData.heading }}
                        </span><br> -->
                        <span class="text-center text-dark">
                            {{ reportHeadData.address }}
                        </span><br>
                        <div class="titleDiv">
                            <span class="text-center text-dark reportTitle" style="font-weight:bold;">
                                  {{ $t('report.mon_fin_repo') }}
                            </span><br>
                        </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" class="text-left mt-4">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                </b-row>
                    <!-- report head data -->
                  <!-- report head data -->
                    <b-row class="details_report">
                      <b-col lg="12" sm="12">
                        <b-row class="mb-1">
                          <b-col lg="12" sm="12">
                            <div class="col-md-12">
                              <!-- <h5 class="font-weight-bold text-capitalize text-center p-2">{{ $t('report.mon_fin_repo') }}</h5> -->
                              <!-- <b-row>
                                <b-col><p class="text-left">{{ $t('social_service.officer_name') }}: </p></b-col>
                              </b-row>
                              <b-row>
                                <b-col><p class="text-left">{{ $t('social_service.month') }}: </p></b-col>
                              </b-row> -->
    <h4 class="font-weight-bold  text-left">{{ $t('report_monthly.worlplace_name') }}: {{this.workplace_name}}</h4>
    <h4 class="font-weight-bold  text-left">{{ $t('report_monthly.month_name') }}: {{this.month_name}}</h4>
                              <b-table-simple small bordered hover responsive>
                                <b-tr>
                                  <b-th colspan="6">{{ $t('report_monthly.money_prv_moth') }}</b-th>
                                  <b-th colspan="3">{{ $t('report_monthly.cash_inc_re_month') }}</b-th>
                                  <b-th colspan="5">{{ $t('report_monthly.inc') }}</b-th>
                                  <b-th rowspan="2">{{ $t('report_monthly.tot_report') }}</b-th>
                                  <b-th rowspan="2">{{ $t('report_monthly.tot_depo') }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <b-th>{{ $t('report_monthly.cash_hand') }}</b-th>
                                  <b-th>{{ $t('report_monthly.bank_dep') }}</b-th>
                                  <b-th>{{ $t('report_monthly.fdr') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_rest_money') }}</b-th>
                                  <b-th>{{ $t('report_monthly.goods_donar') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_rest_money') }}</b-th>
                                  <b-th>{{ $t('report_monthly.govt_donation') }}</b-th>
                                  <b-th>{{ $t('report_monthly.person_donation') }}{{ $t('report_monthly.jakat') }}{{ $t('report_monthly.mem_lif_sub') }}{{ $t('report_monthly.other_source') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_inc') }}</b-th>
                                  <b-th>{{ $t('report_monthly.medicine') }}</b-th>
                                  <b-th>{{ $t('report_monthly.medi_gls_whl') }}</b-th>
                                  <b-th>{{ $t('report_monthly.milk') }}</b-th>
                                  <b-th>{{ $t('report_monthly.clothing') }}</b-th>
                                  <b-th>{{ $t('report_monthly.inc_donr') }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <b-th>{{ $n(1) }}</b-th>
                                  <b-th>{{ $n(2) }}</b-th>
                                  <b-th>{{ $n(3) }}</b-th>
                                  <b-th>{{ $n(4) }}</b-th>
                                  <b-th>{{ $n(5) }}</b-th>
                                  <b-th>{{ $n(6) }}</b-th>
                                  <b-th>{{ $n(7) }}</b-th>
                                  <b-th>{{ $n(8) }}</b-th>
                                  <b-th>{{ $n(9) }}</b-th>
                                  <b-th>{{ $n(10) }}</b-th>
                                  <b-th>{{ $n(11) }}</b-th>
                                  <b-th>{{ $n(12) }}</b-th>
                                  <b-th>{{ $n(13) }}</b-th>
                                  <b-th>{{ $n(14) }}</b-th>
                                  <b-th>{{ $n(15) }}</b-th>
                                  <b-th>{{ $n(16) }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <td>{{ $n(search_report.cash_hand) }}</td>
                                  <td>{{ $n(search_report.bank_dep) }}</td>
                                  <td>{{ $n(search_report.fdr) }}</td>
                                  <td>{{ $n(search_report.tot_rest_money) }}</td>
                                  <td>{{ $n(search_report.goods_donar) }}</td>
                                  <td>{{ $n(search_report.tot_rest_money2) }}</td>
                                  <td>{{ $n(search_report.govt_donation) }}</td>
                                  <td>{{ $n(search_report.other_source) }}</td>
                                  <td>{{ $n(search_report.other_source + search_report.govt_donation) }}</td>
                                  <td>{{ $n(search_report.medicine) }}</td>
                                  <td>{{ $n(search_report.medi_gls_whl) }}</td>
                                  <td>{{ $n(search_report.milk) }}</td>
                                  <td>{{ $n(search_report.clothing) }}</td>
                                  <td>{{ $n(search_report.inc_donr) }}</td>
                                  <td>{{ $n(search_report.medicine+search_report.medi_gls_whl+search_report.milk+search_report.clothing+search_report.inc_donr+search_report.other_source+search_report.govt_donation) }}</td>
                                  <td>{{ $n(search_report.tot_rest_money2+search_report.medicine+search_report.medi_gls_whl+search_report.milk+search_report.clothing+search_report.inc_donr+search_report.other_source+search_report.govt_donation) }}</td>
                                </b-tr>
                              </b-table-simple>
                              <b-table-simple small bordered hover responsive>
                                <b-tr>
                                  <b-th rowspan="2">{{ $t('report_monthly.withdraw_from_bank') }}</b-th>
                                  <b-th colspan="9">{{ $t('report_monthly.money_prv_moth') }}</b-th>
                                  <b-th colspan="5">{{ $t('report_monthly.inc') }}</b-th>
                                  <b-th rowspan="2"> {{ $t('report_monthly.tot_cost_repot_month') }} </b-th>
                                </b-tr>
                                <tr>
                                  <b-th>{{ $t('report.medicine') }}</b-th>
                                  <b-th>{{ $t('report.types_of_test') }}</b-th>
                                  <b-th>{{ $t('report.blood_clothing') }}</b-th>
                                  <b-th>{{ $t('report.wheel_chair') }}</b-th>
                                  <b-th>{{ $t('report_monthly.milk_diet') }}</b-th>
                                  <b-th>{{ $t('report_monthly.fare_cost') }}</b-th>
                                  <b-th>{{ $t('report.dialysis') }}</b-th>
                                  <b-th>{{ $t('report_monthly.miscellaneous') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_cash_out') }}</b-th>
                                  <b-th>{{ $t('report_monthly.medi_gls_whl') }}</b-th>
                                  <b-th>{{ $t('report_monthly.milk_diet') }}</b-th>
                                  <b-th>{{ $t('report_monthly.clothing') }}</b-th>
                                  <b-th>{{ $t('report_monthly.inc_donr_buy') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_cash') }}</b-th>
                                </tr>
                                <b-tr>
                                  <b-th>{{ $n(17) }}</b-th>
                                  <b-th>{{ $n(18) }}</b-th>
                                  <b-th>{{ $n(19) }}</b-th>
                                  <b-th>{{ $n(20) }}</b-th>
                                  <b-th>{{ $n(21) }}</b-th>
                                  <b-th>{{ $n(22) }}</b-th>
                                  <b-th>{{ $n(23) }}</b-th>
                                  <b-th>{{ $n(24) }}</b-th>
                                  <b-th>{{ $n(25) }}</b-th>
                                  <b-th>{{ $n(26) }}</b-th>
                                  <b-th>{{ $n(27) }}</b-th>
                                  <b-th>{{ $n(28) }}</b-th>
                                  <b-th>{{ $n(29) }}</b-th>
                                  <b-th>{{ $n(30) }}</b-th>
                                  <b-th>{{ $n(31) }}</b-th>
                                  <b-th>{{ $n(32) }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <td>{{ $n(search_report.withdraw_from_bank) }}</td>
                                  <td>{{ $n(search_report.medicine2) }}</td>
                                  <td>{{ $n(search_report.types_of_test) }}</td>
                                  <td>{{ $n(search_report.blood) }}/{{ $n(search_report.clothing2) }}</td>
                                  <td>{{ $n(search_report.wheel_chair) }}</td>
                                  <td>{{ $n(search_report.milk_diet) }}</td>
                                  <td>{{ $n(search_report.fare_cost) }}</td>
                                  <td>{{ $n(search_report.dialysis) }}</td>
                                  <td>{{ $n(search_report.miscellaneous) }}</td>
                                  <td>{{ $n(search_report.withdraw_from_bank+search_report.medicine2+search_report.types_of_test+search_report.blood+search_report.clothing2+search_report.wheel_chair+search_report.milk_diet+search_report.miscellaneous+search_report.dialysis+search_report.miscellaneous) }}</td>
                                  <td>{{ $n(search_report.wheel_chair3) }}</td>
                                  <td>{{ $n(search_report.milk_diet3) }}</td>
                                  <td>{{ $n(search_report.blood3) }}/{{ $n(search_report.clothing3) }}</td>
                                  <td>{{ $n(search_report.inc_donr_buy) }}</td>
                                  <td>{{ $n(search_report.wheel_chair3+search_report.milk_diet3+search_report.blood3+search_report.inc_donr_buy+search_report.clothing3) }}</td>
                                  <td>{{ $n(search_report.withdraw_from_bank+search_report.medicine2+search_report.types_of_test+search_report.blood+search_report.clothing2+search_report.wheel_chair+search_report.milk_diet+search_report.miscellaneous+search_report.dialysis+search_report.miscellaneous+search_report.wheel_chair3+search_report.milk_diet3+search_report.blood3+search_report.inc_donr_buy+search_report.clothing3) }}</td>
                                </b-tr>
                              </b-table-simple>
                              <b-table-simple small bordered hover responsive>
                                <b-tr>
                                  <b-th colspan="5">{{ $t('report_monthly.report_mouth_fund') }}</b-th>
                                  <b-th rowspan="2">{{ $t('report_monthly.tot_inc_report') }}</b-th>
                                  <b-th colspan="2">{{ $t('report_monthly.grants_rcv_swc') }}</b-th>
                                  <b-th colspan="3">{{ $t('report_monthly.gnr_assoi') }}</b-th>
                                  <b-th rowspan="2">{{ $t('social_service.comment') }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <b-th>{{ $t('report_monthly.cash_hand') }}</b-th>
                                  <b-th>{{ $t('report_monthly.bank_dep') }}</b-th>
                                  <b-th>{{ $t('report_monthly.fdr') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_rest_money') }}</b-th>
                                  <b-th>{{ $t('report_monthly.grant_from_goods') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_cost_repot_month_NEW') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_cost') }}</b-th>
                                  <b-th>{{ $t('report_monthly.moeny_start') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_semi') }}</b-th>
                                  <b-th>{{ $t('report_monthly.tot_semi_year') }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <b-th>{{ $n(33) }}</b-th>
                                  <b-th>{{ $n(34) }}</b-th>
                                  <b-th>{{ $n(35) }}</b-th>
                                  <b-th>{{ $n(36) }}</b-th>
                                  <b-th>{{ $n(37) }}</b-th>
                                  <b-th>{{ $n(38) }}</b-th>
                                  <b-th>{{ $n(39) }}</b-th>
                                  <b-th>{{ $n(40) }}</b-th>
                                  <b-th>{{ $n(41) }}</b-th>
                                  <b-th>{{ $n(42) }}</b-th>
                                  <b-th>{{ $n(43) }}</b-th>
                                  <b-th>{{ $n(44) }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <td>{{ $n(search_report.cash_hand) }}</td>
                                  <td>{{ $n(search_report.bank_dep) }}</td>
                                  <td>{{ $n(search_report.fdr) }}</td>
                                  <td>{{ $n(search_report.tot_rest_money) }}</td>
                                  <td>{{ $n(search_report.goods_donar) }}</td>
                                  <td>{{ $n(search_report.tot_rest_money+search_report.goods_donar) }}</td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </b-tr>
                                <b-tr>
                                  <!-- <td>{{ $n(search_report.cash_hand) }}</td> -->
                                </b-tr>
                              </b-table-simple>
                            </div>
                          </b-col>

                          <!-- PDF -->
                          <b-col xs="12" sm="12" md="12" class="text-center">
                            <b-overlay :show="loadingPdf">
                              <!-- <b-button-group>
                                  <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                                </b-button-group> -->
                            </b-overlay>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-overlay>
                </template>
              </iq-card>
            </b-col>
          </b-row>
      </b-overlay>
    </template>
  </b-container>
</template>
<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { monthlyFinancialProgressReportApi } from '../../../api/routes'
// import ReportHeading from '@/Utils/report-head'
import RouteBasedList from '@/mixins/route-base-list'
// import Report from './Report'
import ReportHeading from '@/Utils/report-head'
import ExportPdf from './export-pdf-details'

export default {
    mixins: [RouteBasedList],
    components: {
      // Report,
      ValidationObserver,
      ValidationProvider
    },
    data () {
      return {
        titleData: {
          month_name: null
        },
        /** */
        districtList: [],
        upazillaList: [],
        hospitalList: [],
        search: {
          division_id: 0,
          district_id: 0,
          upazilla_id: 0,
          hospital_id: 0,
          month_id: 0,
          fiscal_year_id: 0
        },
        testOptionList: [],
        testList: [],
        loadingReportHeadData: false,
        report_data: [],
        loadingPdf: false,
        dataLoad: false,
          /** */
          search_report: {
            worlplace_name: ' ',
            month_name: ' ',
            cash_hand: '0',
            bank_dep: '0',
            fdr: '0',
            tot_rest_money: '0',
            goods_donar: '0',
            tot_rest_money2: '0',
            govt_donation: '0',
            other_source: '0',
            medicine: '0',
            medi_gls_whl: '0',
            milk: '0',
            clothing: '0',
            inc_donr: '0',
            tot_inc_se: '0',
                withdraw_from_bank: '0',
                medicine2: '0',
                types_of_test: '0',
                blood: '0',
                clothing2: '0',
                wheel_chair: '0',
                milk_diet: '0',
                fare_cost: '0',
                dialysis: '0',
                miscellaneous: '0',
                medicine3: '0',
                types_of_test3: '0',
                blood3: '0',
                clothing3: '0',
                wheel_chair3: '0',
                milk_diet3: '0',
                fare_cost3: '0',
                dialysis3: '0',
                miscellaneous3: '0',
                inc_donr_buy: '0',
                comment: '0'
          },
          reportHeadData: null,
          unitLoad: false
      }
    },
    computed: {
        divisionList: function () {
          return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        yearList: function () {
          const data = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
          const years = data.map((obj, key) => {
            // const year = obj.text.split('-')[0]
            const year = obj.text
            // const year = obj.text
            return { value: obj.text_en.split('-')[1], text: year }
          })
          // Getting the last year on the end of the Fiscal Year List
          // const lastYear = (data[data.length - 1].text.split('-')[1])
          // years.push({ value: lastYear, text: lastYear })
          return years
        },
        monthList () {
          const objectData = this.$store.state.commonObj.monthList
          return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
            } else {
              return { value: obj.value, text: obj.text_en }
            }
          })
        },
        formTitle () {
          return this.$t('report.mon_fin_repo') + ' ' + this.$t('hospital_public_panel.report')
        },
        currentLocale () {
          return this.$i18n.locale
        }
    },
    watch: {
      /** Used to get month name in title data */
      'search.month_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
         this.titleData.month_name = this.getMonthName(newVal)
       }
      },
      'search.division_id': function (newVal, oldVal) {
        this.search.district_id = 0
        this.districtList = this.getDistrictList(newVal)
      },
      'search.district_id': function (newVal, oldVal) {
        this.search.upazilla_id = 0
        this.upazillaList = this.getupazillaList(newVal)
      },
      'search.upazilla_id': function (newVal, oldVal) {
        // Reset both hospital id & list
        this.search.hospital_id = 0
        if (newVal !== 0) {
          this.hospitalList = this.getHospitalListByUpazillaId(newVal)
        } else if (newVal === 0) {
          this.hospitalList = this.getHospitalListAll()
        }
      }
    },
    created () {
      this.headerName()
      this.hospitalList = this.getHospitalListAll()
      this.unitLoad = false
    },
    methods: {
        getDistrictList (divisionId = null) {
          return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
        },
        getupazillaList (districtId = null) {
          return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
        },
        getHospitalListByUpazillaId: function (upazillaId = null) {
          return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.upazilla_id === upazillaId)
        },
        getHospitalListAll: function () {
          return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        },
        getMonthName (mId = null) {
          const monthId = parseInt(mId)
          const objectData = this.monthList.find(month => month.value === monthId)
          return objectData !== undefined ? objectData.text : null
        },
        searchData () {
          this.loadData()
        },
        // Header Data
        async headerName () {
          const result = await ReportHeading.getReportHead(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3)
          this.reportHeadData = result
        },
        async pdfExport () {
          this.loadingPdf = true
            const reportTitle = this.$t('report.mon_fin_repo')
            const data = JSON.parse(JSON.stringify(this.search_report))
            const titleData = { worlplace_name: this.search_report.worlplace_name, month_name: this.search_report.month_name }
            await ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, data, this, titleData)
            this.loadingPdf = false
        },
        // --- Load ---
        loadData () {
          this.dataLoad = true
              const params = Object.assign({}, this.search)
              RestApi.getData(hospitalServiceBaseUrl, monthlyFinancialProgressReportApi, params).then(response => {
                    if (response.success) {
                      this.dataLoad = false
                      this.unitLoad = true
                      const listObject = response
                            this.testList = listObject
                            this.workplace_name = listObject.workplace_name
                            this.month_name = listObject.month_name
                        // this.$bvModal.show('modal-detail-umo')
                        if (this.testList) {
                            this.search_report.cash_hand = this.testList.data.cash_hand
                            this.search_report.bank_dep = this.testList.data.bank_dep
                            this.search_report.fdr = this.testList.data.fdr
                            this.search_report.tot_rest_money = this.testList.data.tot_rest_money
                            this.search_report.goods_donar = this.testList.data.goods_donar
                            this.search_report.tot_rest_money2 = this.testList.data.tot_rest_money2
                            this.search_report.govt_donation = this.testList.data.govt_donation
                            this.search_report.other_source = this.testList.data.other_source
                            this.search_report.medicine = this.testList.data.medicine
                            this.search_report.medi_gls_whl = this.testList.data.medi_gls_whl
                            this.search_report.milk = this.testList.data.milk
                            this.search_report.clothing = this.testList.data.clothing
                            this.search_report.inc_donr = this.testList.data.inc_donr
                            this.search_report.tot_inc_se = this.testList.data.tot_inc_se
                                  this.search_report.withdraw_from_bank = this.testList.data.withdraw_from_bank
                                  this.search_report.medicine2 = this.testList.data.medicine2
                                  this.search_report.types_of_test = this.testList.data.types_of_test
                                  this.search_report.blood = this.testList.data.blood
                                  this.search_report.clothing2 = this.testList.data.clothing2
                                  this.search_report.wheel_chair = this.testList.data.wheel_chair
                                  this.search_report.milk_diet = this.testList.data.milk_diet
                                  this.search_report.fare_cost = this.testList.data.fare_cost
                                  this.search_report.dialysis = this.testList.data.dialysis
                                  this.search_report.miscellaneous = this.testList.data.miscellaneous
                                  this.search_report.medicine3 = this.testList.data.medicine3
                                  this.search_report.types_of_test3 = this.testList.data.types_of_test3
                                  this.search_report.blood3 = this.testList.data.blood3
                                  this.search_report.clothing3 = this.testList.data.clothing3
                                  this.search_report.wheel_chair3 = this.testList.data.wheel_chair3
                                  this.search_report.milk_diet3 = this.testList.data.milk_diet3
                                  this.search_report.fare_cost3 = this.testList.data.fare_cost3
                                  this.search_report.dialysis3 = this.testList.data.dialysis3
                                  this.search_report.miscellaneous3 = this.testList.data.miscellaneous3
                                  this.search_report.inc_donr_buy = this.testList.data.inc_donr_buy
                          }
                    }
              })
        }
    }
}
</script>
<style lang="scss">
  .titleDiv {
    font-size: 18px;
  }
  .details_report {
    font-size: 8px;
    color: #000;
    h5 {
      color: green !important;
      font-size: 12px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
    .table-bordered th {
      text-align: center;
      font-size: 11px !important;
      // font-weight: 900 !important;
    }
    .table-bordered tr td {
      font-size: 9px !important;
      text-align: center;
    }
  }
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
